(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    // Find the modal before moving it outside the product section.
    const modal = root.querySelector('[data-ds-modal]');
    const productSection = root.closest('.shopify-section') || document;

    // Search both the original product section and the modal.
    const $ = (selector) =>
      root.querySelector(selector) || modal?.querySelector(selector);

    const dialog = $('.ds-dialog');
    const content = $('.ds-content');
    const form = $('[data-ds-form]');
    const error = $('[data-ds-error]');

    if (!modal || !dialog || !form || !error) {
      console.error('Dr Stitches customizer: Required elements are missing.');
      return;
    }

    // Prices and variant IDs come from the customizer's data attributes.
    const price = (key) => Number(root.dataset[key] || 0);
    const variant = (key) => String(root.dataset[key] || '').trim();
    const isLabcoat = root.dataset.dsMode === 'labcoat';
    const labcoatEmbroideryVariant = '52911190245607';

    let sizingMode = 'standard';
    let customizationSaved = false;
    let savedProperties = {};
    let savedAddons = [];

    const checked = (selector) =>
      root.querySelector(selector + ':checked') ||
      modal.querySelector(selector + ':checked');

    const sizing = () =>
      isLabcoat
        ? 'Standard sizing'
        : sizingMode === 'standard'
          ? 'Standard sizing'
          : 'Custom sizing';

    const productForm = () => {
      const section = root.closest('.shopify-section');
      return (
        section?.querySelector('product-form form') ||
        section?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('product-form form')
      );
    };

    const standardSizePicker = () =>
      root.closest('.shopify-section')?.querySelector('[id^="ds-size-picker-"]') ||
      document.querySelector('[id^="ds-size-picker-"]');

    const standardSizeInput = () =>
      standardSizePicker()?.querySelector('[data-ds-size-value]');

    const trouserInput = () =>
      root.closest('.shopify-section')?.querySelector('[data-ds-trouser-value]') ||
      document.querySelector('[data-ds-trouser-value]');

    function setFormProperties(values) {
      const targetForm = productForm();
      if (!targetForm) return;

      targetForm
        .querySelectorAll('[data-ds-generated-property]')
        .forEach((el) => el.remove());

      Object.entries(values).forEach(([key, value]) => {
        if (value === '' || value == null) return;

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = String(value);
        input.dataset.dsGeneratedProperty = 'true';

        targetForm.appendChild(input);
      });
    }

    const embroidery = () =>
      $('[data-ds-embroidery]')?.value || 'none';

    const hasName = () =>
      ['name', 'both'].includes(embroidery());

    const hasLogo = () =>
      !isLabcoat && ['logo', 'both'].includes(embroidery());

    const money = (amount) =>
      'Rs. ' + Number(amount).toLocaleString('en-PK');

    function updateShirtImage() {
      const image = $('[data-ds-shirt-image]');
      if (!image) return;

      const isLabcoat = root.dataset.dsMode === 'labcoat';

      let imageKey = 'imageNone';

      if (hasName() || hasLogo()) {
        const placement = $('[data-ds-name-placement]')?.value;

        imageKey = placement === 'Right chest'
          ? 'imageRight'
          : 'imageLeft';
      }

      let nextImage;

      if (isLabcoat) {
        nextImage = image.dataset[imageKey];
      } else {
        nextImage = image.dataset[imageKey];
      }

      if (nextImage && image.src !== nextImage) {
        image.src = nextImage;
      }
    }

    function updateEmbroideryPreview() {
      const previewName = $('[data-ds-preview-caption-name]');
      const previewDesignation =
        $('[data-ds-preview-caption-designation]');

      const nameInput = $('[data-ds-line1]');
      const designationInput = $('[data-ds-line2]');
      const linesSelect = $('[data-ds-lines]');

      if (!previewName || !previewDesignation) return;

      if (!hasName()) {
        previewName.textContent = '';
        previewDesignation.textContent = '';
        return;
      }

      previewName.textContent =
        nameInput?.value.trim() || 'Your Name';

      const twoLines = linesSelect?.value === '2';

      previewDesignation.textContent = twoLines
        ? designationInput?.value.trim() || 'Your Designation'
        : '';
    }

    // Calculate the total customization fees.
    function total() {
      let amount = 0;

      if (!isLabcoat) {
        ['sleeve', 'shirt', 'trouser'].forEach((key) => {
          if ($(`[data-ds-adjust="${key}"]`)?.checked) {
            amount += price(key + 'Price');
          }
        });
      }

      if (hasName()) {
        amount += isLabcoat ? 300 : price('namePrice');
      }

      if (hasLogo()) {
        amount += price('logoPrice');
      }

      return amount;
    }

    // Position the embroidery button based on the selected sizing type.
    function positionEmbroideryLauncher() {
      if (isLabcoat) return;

      const launchBlock = productSection.querySelector(
        '.ds-customizer-launch-block'
      );

      const trouserBlock = productSection.querySelector(
        '.ds-trouser-picker'
      );

      if (!launchBlock || !trouserBlock) return;

      if (sizingMode === 'standard') {
        // Standard: embroidery button AFTER Trouser Style.
        if (trouserBlock.nextElementSibling !== launchBlock) {
          trouserBlock.insertAdjacentElement('afterend', launchBlock);
        }
      } else {
        // Custom: embroidery button BEFORE Trouser Style.
        if (launchBlock.nextElementSibling !== trouserBlock) {
          trouserBlock.insertAdjacentElement('beforebegin', launchBlock);
        }
      }
    }

    // Update visible fields when sizing or embroidery changes.
    function refresh() {
      const custom = !isLabcoat && sizingMode === 'custom';
      const measurements = $('[data-ds-measurements]');
      const baseSizeWrap = $('[data-ds-base-size-wrap]');
      const sizePicker = standardSizePicker();
      const sizingStep = $('[data-ds-sizing-step]');
      const launchLabel = productSection.querySelector('[data-ds-launch-label]');
      const modalDescription = $('[data-ds-modal-description]');
      const embroideryStepNumber = $('[data-ds-embroidery-step-number]');

      if (sizingStep) sizingStep.hidden = !custom;

      if (launchLabel && !isLabcoat) {
        launchLabel.textContent =
          sizingMode === 'standard' ? 'Add Embroidery' : 'Customize Your Scrubs';
      }

      if (modalDescription && !isLabcoat) {
        modalDescription.textContent =
          sizingMode === 'standard'
            ? 'Add optional embroidery to your scrubs.'
            : 'Choose your sizing and optional embroidery below.';
      }

      const modalHeading = $('[id^="ds-heading-"]');

      if (modalHeading && !isLabcoat) {
        modalHeading.textContent =
          sizingMode === 'standard' ? 'Add Embroidery' : 'Customize Your Scrubs';
      }

      if (embroideryStepNumber && !isLabcoat) {
        embroideryStepNumber.textContent = custom ? '02' : '01';
      }

      if (measurements) measurements.hidden = !custom;
      if (baseSizeWrap) baseSizeWrap.hidden = !custom;

      modal
        .querySelectorAll('input[name^="ds-base-size-"]')
        .forEach((el) => {
          el.required = custom;
        });

      if (!custom) {
        modal
          .querySelectorAll('input[name^="ds-base-size-"]')
          .forEach((el) => {
            el.checked = false;
          });
      }

      if (custom && sizePicker) {
        const standardInput = standardSizeInput();
        if (standardInput) standardInput.value = '';

        sizePicker.querySelectorAll('[data-size]').forEach((btn) => {
          btn.setAttribute('aria-pressed', 'false');
        });
      }

      if (sizePicker) sizePicker.hidden = isLabcoat || custom;

      root.querySelectorAll('[data-ds-sizing-choice]').forEach((choice) => {
        const active = choice.dataset.dsSizingChoice === sizingMode;
        choice.setAttribute('aria-pressed', String(active));
        choice.classList.toggle('is-active', active);
      });

      ['sleeve', 'shirt', 'trouser'].forEach((key) => {
        const checkbox = $(`[data-ds-adjust="${key}"]`);
        const input = $(`[data-ds-measure="${key}"]`);

        if (!checkbox || !input) return;

        if (!custom) {
          checkbox.checked = false;
          input.value = '';
        }

        input.hidden = !custom || !checkbox.checked;
        input.required = custom && checkbox.checked;
      });

      const nameFields = $('[data-ds-name-fields]');
      const logoFields = $('[data-ds-logo-fields]');

      if (nameFields) nameFields.hidden = !hasName();
      if (logoFields) logoFields.hidden = !hasLogo();

      const linesSelect = $('[data-ds-lines]');
      const line1 = $('[data-ds-line1]');
      const line2 = $('[data-ds-line2]');
      const line2Wrap = $('[data-ds-line2-wrap]');
      const twoLines = linesSelect?.value === '2';

      if (line2Wrap) {
        line2Wrap.hidden = !hasName() || !twoLines;
      }

      if (line1) line1.required = hasName();
      if (line2) line2.required = hasName() && twoLines;

      if (!hasName()) {
        if (line1) line1.value = '';
        if (line2) line2.value = '';
      }

      if (!hasLogo()) {
        modal
          .querySelectorAll('input[name^="ds-logo-"]')
          .forEach((el) => {
            el.checked = false;
          });
      }

      const totalElement = $('[data-ds-total]');

      if (totalElement) {
        totalElement.textContent = money(total());
      }

      updateEmbroideryPreview();
      updateShirtImage();
      positionEmbroideryLauncher();
    }

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    // Find the actual Shopify product variant selected on the page.
    function selectedVariantId() {
      const forms = [
        root.closest('.shopify-section')
          ?.querySelector('product-form form [name="id"]'),
        document.querySelector('product-form form [name="id"]'),
        document.querySelector('form[action*="/cart/add"] [name="id"]')
      ].filter(Boolean);

      for (const input of forms) {
        if (/^\d+$/.test(input.value || '')) {
          return input.value;
        }
      }

      return '';
    }

    // Save customization details as properties on the main product.
    function properties() {
      if (isLabcoat) {
        const result = {
          'Customization type': 'Lab coat embroidery',
          'Embroidery': hasName() ? 'Name embroidery' : 'None'
        };

        if (hasName()) {
          result['Name placement'] =
            $('[data-ds-name-placement]')?.value || '';

          result['Name line 1'] =
            $('[data-ds-line1]')?.value.trim() || '';

          result['Number of name lines'] =
            $('[data-ds-lines]')?.value || '1';

          if ($('[data-ds-lines]')?.value === '2') {
            result['Name line 2'] =
              $('[data-ds-line2]')?.value.trim() || '';
          }

          result['Name embroidery fee'] = money(300);
        }
                return result;
      }

      const result = {
        'Sizing type': sizing(),

        ...(sizingMode === 'custom'
          ? {
              'Base size':
                checked('input[name^="ds-base-size-"]')?.value || ''
            }
          : {
              'Standard Size': standardSizeInput()?.value || ''
            }),

        'Embroidery':
          embroidery() === 'none'
            ? 'None'
            : embroidery() === 'both'
              ? 'Name + medical logo'
              : embroidery() === 'name'
                ? 'Name embroidery'
                : 'Medical logo'
      };

      if (sizing() === 'Custom sizing') {
        ['sleeve', 'shirt', 'trouser'].forEach((key) => {
          const checkbox = $(`[data-ds-adjust="${key}"]`);
          const input = $(`[data-ds-measure="${key}"]`);

          if (checkbox?.checked && input) {
            const label = {
              sleeve: 'Sleeve length',
              shirt: 'Shirt length',
              trouser: 'Trouser length'
            }[key];

            result[label + ' (inches)'] = input.value;
            result[label + ' fee'] = money(price(key + 'Price'));
          }
        });
      }

      if (hasName()) {
        result['Name placement'] =
          $('[data-ds-name-placement]')?.value || '';

        result['Name line 1'] =
          $('[data-ds-line1]')?.value.trim() || '';

        result['Number of name lines'] =
          $('[data-ds-lines]')?.value || '1';

        if ($('[data-ds-lines]')?.value === '2') {
          result['Name line 2'] =
            $('[data-ds-line2]')?.value.trim() || '';
        }

        result['Name embroidery fee'] = money(price('namePrice'));
      }

      if (hasLogo()) {
        result['Medical logo'] =
          checked('input[name^="ds-logo-"]')?.value || '';

        result['Logo placement'] =
          $('[data-ds-logo-placement]')?.value || '';

        result['Logo embroidery fee'] = money(price('logoPrice'));
      }

      return result;
    }

    // Add the appropriate paid add-on variants to the cart.
    function addonItems() {
      const items = [];

      // Lab coats use the dedicated Rs. 300 embroidery product variant.
      if (isLabcoat) {
        if (hasName()) {
          items.push({
            id: Number(labcoatEmbroideryVariant),
            quantity: 1,
            properties: {
              'Customization add-on': 'Lab coat name embroidery',
              'Customized product': root.dataset.productTitle || 'Lab coat',
              'Name placement':
                $('[data-ds-name-placement]')?.value || '',
              'Name line 1':
                $('[data-ds-line1]')?.value.trim() || '',
              'Number of name lines':
                $('[data-ds-lines]')?.value || '1',
              ...(
                $('[data-ds-lines]')?.value === '2'
                  ? {
                      'Name line 2':
                        $('[data-ds-line2]')?.value.trim() || ''
                    }
                  : {}
              ),
              '_Dr Stitches customization': 'yes'
            }
          });
        }

        return items;
      }

      function add(key, enabled, title, fee) {
        if (!enabled || fee <= 0) return;

        const id = variant(key);

        if (!/^\d+$/.test(id)) {
          throw new Error(
            'The add-on variant ID for "' + title +
            '" is missing. Please contact the store administrator.'
          );
        }

        items.push({
          id: Number(id),
          quantity: 1,
          properties: {
            'Customization add-on': title,
            'Customized product': root.dataset.productTitle,
            '_Dr Stitches customization': 'yes'
          }
        });
      }

      const custom = sizing() === 'Custom sizing';

      add(
        'sleeveVariant',
        custom && $('[data-ds-adjust="sleeve"]')?.checked,
        'Sleeve adjustment',
        price('sleevePrice')
      );

      add(
        'shirtVariant',
        custom && $('[data-ds-adjust="shirt"]')?.checked,
        'Shirt adjustment',
        price('shirtPrice')
      );

      add(
        'trouserVariant',
        custom && $('[data-ds-adjust="trouser"]')?.checked,
        'Trouser adjustment',
        price('trouserPrice')
      );

      add(
        'nameVariant',
        hasName(),
        'Name embroidery',
        price('namePrice')
      );

      add(
        'logoVariant',
        hasLogo(),
        'Medical logo embroidery',
        price('logoPrice')
      );

      return items;
    }

    // Open the popup.
    function openModal() {
      modal.hidden = false;
      document.body.classList.add('ds-modal-open');

      if (content) content.scrollTop = 0;

      refresh();
      dialog.focus();
    }

    // Close the popup and restore page scrolling.
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('ds-modal-open');
    }

    // The launch button is a separate product block placed after Trouser Style.
    // Bind within the same Shopify product section because the button is no longer
    // nested inside the customizer root.
    productSection.querySelectorAll('[data-ds-open]').forEach((button) => {
      if (button.dataset.dsOpenBound === 'true') return;

      button.dataset.dsOpenBound = 'true';
      button.addEventListener('click', openModal);
    });

    // Close buttons and backdrop are inside the modal.
    modal.querySelectorAll('[data-ds-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    // Support closing with Escape.
    document.addEventListener('keydown', (event) => {
      if (!modal.hidden && event.key === 'Escape') {
        closeModal();
      }
    });

    modal.querySelectorAll('input, select').forEach((field) => {
      field.addEventListener('input', () => {
        showError('');
        refresh();
      });

      field.addEventListener('change', () => {
        showError('');
        refresh();
      });
    });

    // Save scrub customization to the Shopify product form.
    // Lab coats retain their existing customization-save behaviour.
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      showError('');

      if (!form.reportValidity()) return;

      if (
        !isLabcoat &&
        sizingMode === 'custom' &&
        !checked('input[name^="ds-base-size-"]')
      ) {
        showError('Please select your base size.');
        return;
      }

      if (
        !isLabcoat &&
        sizingMode === 'standard' &&
        !standardSizeInput()?.value.trim()
      ) {
        showError('Please select your Standard Size on the product page.');
        return;
      }

      if (hasLogo() && !checked('input[name^="ds-logo-"]')) {
        showError('Please choose a medical logo.');
        return;
      }

      if (isLabcoat) {
        try {
          savedProperties = properties();
          savedAddons = addonItems();
        } catch (err) {
          showError(err.message);
          return;
        }

        setFormProperties(savedProperties);
        customizationSaved = true;

        closeModal();

        const buttonText = $('[data-ds-submit-label]');

        if (buttonText) {
          buttonText.textContent = 'Save Customization';
        }

        let toast = document.querySelector('[data-ds-customization-saved]');

        if (!toast) {
          toast = document.createElement('div');
          toast.dataset.dsCustomizationSaved = '';
          toast.setAttribute('role', 'status');
          toast.className = 'ds-save-confirmation';
          root.appendChild(toast);
        }

        toast.textContent =
          'Embroidery customization saved. You can now add your lab coat to the cart.';
        toast.hidden = false;

        return;
      }

      try {
        savedProperties = properties();
        savedAddons = addonItems();
      } catch (err) {
        showError(err.message);
        return;
      }

      const trouser = trouserInput()?.value.trim();

      if (trouser) {
        savedProperties['Trouser Style'] = trouser;
      }

      savedProperties['Sizing type'] = sizing();

      setFormProperties(savedProperties);
      customizationSaved = true;

      closeModal();

      const buttonText = $('[data-ds-submit-label]');

      if (buttonText) {
        buttonText.textContent = 'Save Customization';
      }

      let toast = document.querySelector('[data-ds-customization-saved]');

      if (!toast) {
        toast = document.createElement('div');
        toast.dataset.dsCustomizationSaved = '';
        toast.setAttribute('role', 'status');
        toast.className = 'ds-save-confirmation';
        root.appendChild(toast);
      }

      toast.textContent =
        'Customization saved. You can now add your scrubs to the cart.';
      toast.hidden = false;
    });

    // Intercept the theme's single Add to Cart submission so the main product
    // and fees are added together.
    const mainForm = productForm();

    if (mainForm && !mainForm.dataset.dsUnifiedCart) {
      mainForm.dataset.dsUnifiedCart = 'true';

      mainForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        // LAB COAT CART LOGIC
        // Add the lab coat and its embroidery add-on in ONE request.
        // This prevents the embroidery product from being added separately.
        if (isLabcoat) {
          if (!customizationSaved) {
            try {
              savedProperties = properties();
              savedAddons = addonItems();
              setFormProperties(savedProperties);
              customizationSaved = true;
            } catch (err) {
              showError(err.message);
              return;
            }
          }

          const labcoatId = mainForm.querySelector('[name="id"]')?.value;

          if (!/^\d+$/.test(labcoatId || '')) {
            showError('Please select a valid lab coat option.');
            return;
          }

          const labcoatQuantity = Math.max(
            1,
            parseInt(
              mainForm.querySelector('[name="quantity"]')?.value || '1',
              10
            )
          );

          // Main lab coat is included exactly once.
          // The embroidery variant is included only when name embroidery is selected.
          const labcoatItems = [
            {
              id: Number(labcoatId),
              quantity: labcoatQuantity,
              properties: savedProperties
            },
            ...savedAddons
          ];

          const labcoatCart =
            document.querySelector('cart-drawer') ||
            document.querySelector('cart-notification');

          const labcoatButton = mainForm.querySelector('[type="submit"]');

          if (labcoatButton) {
            labcoatButton.disabled = true;
            labcoatButton.classList.add('loading');
          }

          try {
            const sections =
              labcoatCart?.getSectionsToRender?.().map(section => section.id) || [];

            const response = await fetch(
              (window.Shopify?.routes?.root || '/') + 'cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  items: labcoatItems,
                  ...(sections.length
                    ? {
                        sections,
                        sections_url: window.location.pathname
                      }
                    : {})
                })
              }
            );

            const data = await response.json();

            if (!response.ok) {
              throw new Error(
                data.description ||
                data.message ||
                'Unable to add the lab coat to your cart.'
              );
            }

            if (labcoatCart?.renderContents) {
              labcoatCart.renderContents(data);
            } else {
              window.location.href =
                (window.Shopify?.routes?.root || '/') + 'cart';
            }

            customizationSaved = false;
            savedProperties = {};
            savedAddons = [];
          } catch (err) {
            showError(
              err.message || 'Unable to add the lab coat to your cart.'
            );
          } finally {
            if (labcoatButton) {
              labcoatButton.disabled = false;
              labcoatButton.classList.remove('loading');
            }
          }

          return;
        }
                // SCRUB LOGIC — unchanged.
        // Custom sizing requires the customer to save their customization.
        // Standard sizing does not require opening the embroidery popup.
        if (!customizationSaved) {
          if (sizingMode === 'custom') {
            showError(
              'Please choose your sizing type and click Save Customization before adding to cart.'
            );
            openModal();
            return;
          }

          // Standard sizing: embroidery is optional.
          // Automatically collect the default or selected embroidery options.
          try {
            savedProperties = properties();
            savedAddons = addonItems();
            savedProperties['Sizing type'] = sizing();
            customizationSaved = true;
          } catch (err) {
            showError(err.message);
            return;
          }
        }

        const standard = sizingMode === 'standard';

        if (standard && !standardSizeInput()?.value.trim()) {
          showError('Please select your Standard Size.');
          standardSizePicker()?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          return;
        }

        if (
          !standard &&
          !checked('input[name^="ds-base-size-"]') &&
          !savedProperties['Base size']
        ) {
          showError('Please select your Base Size.');
          openModal();
          return;
        }

        // Trouser Style is required only when its picker exists.
        // Scrub tops and scrub shirts do not have this picker.
        const trouserPicker = trouserInput();
        const selectedTrouser = trouserPicker?.value.trim();

        if (trouserPicker && !selectedTrouser) {
          showError('Please select a Trouser Style.');
          trouserPicker.closest('.ds-trouser-picker')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          return;
        }

        const id = mainForm.querySelector('[name="id"]')?.value;

        if (!/^\d+$/.test(id || '')) {
          showError('Please select a valid product option.');
          return;
        }

        const quantity = Math.max(
          1,
          parseInt(mainForm.querySelector('[name="quantity"]')?.value || '1', 10)
        );

        // Only add the Trouser Style property when a picker exists
        // and the customer has selected a style.
        const props = {
          ...savedProperties,
          'Sizing type': sizing(),
          ...(selectedTrouser
            ? { 'Trouser Style': selectedTrouser }
            : {})
        };

        const items = [
          {
            id: Number(id),
            quantity,
            properties: props
          },
          ...savedAddons
        ];

        const cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        const button = mainForm.querySelector('[type="submit"]');

        if (button) {
          button.disabled = true;
          button.classList.add('loading');
        }

        try {
          const sections =
            cart?.getSectionsToRender?.().map(s => s.id) || [];

          const response = await fetch(
            (window.Shopify?.routes?.root || '/') + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items,
                ...(sections.length
                  ? {
                      sections,
                      sections_url: window.location.pathname
                    }
                  : {})
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              'Unable to add items to your cart.'
            );
          }

          if (cart?.renderContents) {
            cart.renderContents(data);
          } else {
            window.location.href =
              (window.Shopify?.routes?.root || '/') + 'cart';
          }

          customizationSaved = false;
        } catch (err) {
          showError(err.message || 'Unable to add items to your cart.');
        } finally {
          if (button) {
            button.disabled = false;
            button.classList.remove('loading');
          }
        }
      }, true);
    }

    // Sizing mode controls live in the popup; mode is selected on the product page.
    root.querySelectorAll('[data-ds-sizing-choice]').forEach((choice) => {
      choice.addEventListener('click', () => {
        sizingMode = choice.dataset.dsSizingChoice;
        customizationSaved = false;
        savedProperties = {};
        savedAddons = [];

        const sizeInput = standardSizeInput();

        if (sizeInput && sizingMode === 'custom') {
          sizeInput.value = '';
        }

        modal
          .querySelectorAll('input[name^="ds-base-size-"]')
          .forEach((el) => {
            if (sizingMode === 'standard') {
              el.checked = false;
            }
          });

        setFormProperties({});
        refresh();
      });
    });

    // Move the modal outside the product section so it can
    // layer above the storefront header and page content.
    if (modal.parentElement !== document.body) {
      const styles = getComputedStyle(root);

      [
        '--ds-purple',
        '--ds-violet',
        '--ds-border',
        '--ds-maroon',
        '--ds-muted'
      ].forEach((name) => {
        const value = styles.getPropertyValue(name).trim();

        if (value) {
          modal.style.setProperty(name, value);
        }
      });

      // Preserve the CSS scope after moving the popup to the body.
      modal.classList.add('ds-customizer');
      modal.dataset.dsMode = root.dataset.dsMode || 'scrubs';

      document.body.appendChild(modal);
    }

    // Customizer main tabs.
    const customizerTabs = modal.querySelectorAll('[data-ds-tab]');
    const customizerPanels = modal.querySelectorAll('[data-ds-panel]');

    customizerTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.dsTab;

        customizerTabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });

        customizerPanels.forEach((panel) => {
          panel.hidden = panel.dataset.dsPanel !== selected;
        });
      });
    });

    // Scrub set shirt/trouser chart switch.
    const guideButtons = modal.querySelectorAll('[data-ds-guide]');
    const guidePanels = modal.querySelectorAll('[data-ds-guide-panel]');

    guideButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.dsGuide;

        guideButtons.forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });

        guidePanels.forEach((panel) => {
          panel.hidden = panel.dataset.dsGuidePanel !== selected;
        });
      });
    });

    refresh();
  }

  function boot() {
    document
      .querySelectorAll('[data-ds-customizer]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();